<template>
    <div v-if="hasActiveFilters" class="active-filters">
        <div class="active-filters__container">
            <filter-pill
                v-for="filter in allActiveFilters"
                :key="`${filter.type}-${filter.value}`"
                :value="filter.value"
                :label="filter.label"
                :type="filter.type"
                @remove="handleFilterRemove"
            />
        </div>
    </div>
</template>

<script>
import FilterPill from './FilterPill.vue';

export default {
    name: 'ActiveFilters',
    components: {
        FilterPill,
    },
    props: {
        selectedMarkets: {
            type: Array,
            default: () => []
        },
        selectedTopics: {
            type: Array,
            default: () => []
        },
        marketOptions: {
            type: Array,
            default: () => []
        },
        topicOptions: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        marketFilters() {
            return this.selectedMarkets.map((marketId) => {
                const market = this.marketOptions.find(m => m.id === marketId || m.value === marketId);
                return {
                    type: 'market',
                    value: marketId,
                    label: market ? market.name || market.label : `Market ${marketId}`
                };
            });
        },
        topicFilters() {
            return this.selectedTopics.map(topicId => {
                const topic = this.topicOptions.find(t => t.id === topicId || t.value === topicId);
                return {
                    type: 'topic',
                    value: topicId,
                    label: topic ? topic.name || topic.label : `Topic ${topicId}`
                };
            });
        },
        allActiveFilters() {
            return [...this.marketFilters, ...this.topicFilters];
        },
        hasActiveFilters() {
            return this.allActiveFilters.length > 0;
        }
    },
    methods: {
        handleFilterRemove(filter) {
            this.$emit('filter-remove', filter);
        }
    }
};
</script>

<style scoped>
.active-filters {
    margin: 30px 0;
}

.active-filters__container {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    align-items: center;
    max-width: 1080px;
    margin: 0 auto;
}

/* Remove the default margin from filter pills when used in this container */
.active-filters__container >>> .filter-pill {
    margin-right: 0;
    margin-bottom: 0;
}

@media (max-width: 768px) {
    .active-filters {
        margin-bottom: 16px;
        padding: 0 20px;
    }
    
    .active-filters__container {
        gap: 6px;
    }
}
</style>